import React, {Component} from "react";
import {DataGridContainer} from "app/modules/common/grid/data-grid-container";
import {DataGridHeader} from "app/modules/common/grid/data-grid-header";
import {Button, Grid, InputBase} from "@mui/material";
import {DataGridBody} from "app/modules/common/grid/data-grid-body";
import {DataGridPro, GridRenderCellParams} from "@mui/x-data-grid-pro";
import {inject, provider} from "react-ioc";
import {observer} from "mobx-react";
import {UsersStore} from "app/modules/admin/components/users/UsersStore";
import {Link} from "react-router-dom";
import {NavigationStore} from "app/modules/admin/stores/NavigationStore";
import {PageTitleChip} from "app/modules/common/layout/components/page-title";
import {BoxCenter} from "app/modules/common/layout/components/containers";
import {SearchPaper, SearchVerDivider} from "app/modules/common/layout/components/search";
import {DateTimeHelper} from "app/modules/common/helpers/DateTimeHelper";
import {UserListModel, UserType} from "app/modules/admin/api/clients.api";
import Moment from "moment";
import {Loading} from "app/modules/common/layout/components/loading";
import {StringHelper} from "app/modules/common/helpers/StringHelper";
import {Paths} from "app/modules/admin/stores/paths";

const columns = [
    {
        field: 'name',
        headerName: 'Name',
        minWidth: 250,
        flex: 5,
        renderCell: (params: GridRenderCellParams<UserListModel>) => (
            <Link to={Paths.EditUser.nav(params.row.id)}>{params.row.fullName}</Link>
        ),
    },
    {
        field: 'email',
        headerName: 'Email',
        minWidth: 250,
        flex: 1
    },
    {
        field: 'emailConfirmed',
        headerName: 'Confirmed',
        minWidth: 150,
        flex: 1,
        renderCell: (params: GridRenderCellParams<UserListModel>) => (
            StringHelper.formatYesNo(params.row.emailConfirmed)
        ),
    },
    {
        field: 'userType',
        headerName: 'Type',
        minWidth: 150,
        flex: 1,
        renderCell: (params: GridRenderCellParams<UserListModel>) => (
            params.row.userType == UserType.Internal ? "Internal" : "Tenant"
        ),
    },
    {
        field: 'organizationName',
        headerName: 'organization',
        minWidth: 150,
        flex: 1,
        renderCell: (params: GridRenderCellParams<UserListModel>) => (
            params.row.organizationName || "-"
        ),
    },
    {
        field: 'lockoutEnd',
        headerName: 'Locked',
        minWidth: 150,
        flex: 1,
        renderCell: (params: GridRenderCellParams<UserListModel>) => (
            params.row.lockoutEnd && Moment().diff(params.row.lockoutEnd, "minutes") > 0 && DateTimeHelper.formatMomentDateTime(params.row.lockoutEnd) || "-"
        ),
    },
    {
        field: 'createdAt',
        headerName: 'CreatedAt',
        minWidth: 150,
        flex: 1,
        renderCell: (params: GridRenderCellParams<UserListModel>) => (
            DateTimeHelper.formatMomentDateTime(params.row.createdAt)
        ),
    }
];

@provider(UsersStore)
@observer
export default class Index extends Component<any, any> {
    @inject usersStore: UsersStore;
    @inject navigationStore: NavigationStore;

    render() {
        if(this.usersStore.isInitLoading) {
            return <Loading />;
        }

        return <DataGridContainer>
            <Grid item xs={12}>
                <PageTitleChip Title={this.navigationStore.title} TotalRows={this.usersStore.totalRows}/>
            </Grid>
            <DataGridHeader>
                <BoxCenter>
                    <SearchPaper width={400}>
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            value={this.usersStore.filters.$.search.value}
                            onChange={(e)=>this.usersStore.filters.$.search.onChange(e.target.value)}
                            placeholder="Search"
                            inputProps={{ 'aria-label': 'search' }}
                        />
                        <SearchVerDivider />
                        <Button variant="text" onClick={this.usersStore.applyFilters}>Search</Button>
                    </SearchPaper>
                </BoxCenter>
            </DataGridHeader>
            <DataGridBody>
                <DataGridPro
                    disableVirtualization
                    rows={this.usersStore.items}
                    columns={columns}
                    pageSize={this.usersStore.pageSize}
                    rowsPerPageOptions={this.usersStore.pageSizeOptions}
                    rowCount={this.usersStore.totalRows}
                    page={this.usersStore.skipRows/this.usersStore.pageSize}
                    loading={this.usersStore.isLoading}
                    pagination
                    paginationMode="server"
                    disableColumnFilter
                    disableColumnSelector
                    disableSelectionOnClick
                    checkboxSelection={false}
                    onPageChange={(page) => this.usersStore.setPage(page)}
                    onPageSizeChange={(pageSize) => this.usersStore.setPageSize(pageSize) }/>
            </DataGridBody>
        </DataGridContainer>;
    }

    componentDidMount() {
        this.usersStore.init();
    }
}

